export const PERMISSIONS_CONFIG = {
  pages: [
    { id: 'dashboard',      name: 'Dashboard' },
    { id: 'orders',         name: 'Orders Page' },
    { id: 'ordersNew',      name: 'New Orders Page' },
    { id: 'v9Orders',       name: 'V9 Orders' },
    { id: 'v9ActionQueue',  name: 'V9 Action Queue' },
    { id: 'inventory',      name: 'Inventory Page' },
    { id: 'stockHouse',     name: 'Stock House' },
    { id: 'batches',        name: 'Production Batches' },
    { id: 'products',       name: 'Product Catalog' },
    { id: 'bundles',        name: 'Bundle Definitions' },
    { id: 'admin',          name: 'Admin/System Page' },
    { id: 'users',          name: 'User Management' },
    { id: 'fabricSpecs',    name: 'Fabric Specs' },
    { id: 'support',        name: 'Customer Support' },
    { id: 'blog',           name: 'Blog Automation' },
    { id: 'lookbookApproval', name: 'Lookbook Approval' },
    { id: 'b2bPricing',      name: 'B2B Pricing Tiers' },
    { id: 'offers',          name: 'Current Offers' },
    { id: 'fulfillment',     name: 'Fulfillment Hub' },
    { id: 'vendorBills',     name: 'Vendor Bills Automation' },
    { id: 'orderDesk',      name: 'Order Desk' },
    { id: 'b2bExport',      name: 'B2B Export' },
  ],
  // Each action carries a `page` key so the UI can group them by page.
  actions: [
    // ── Orders Page ──────────────────────────────────────────────────────
    { id: 'orders.create',           page: 'orders',        name: 'Create Order Button' },
    { id: 'orders.ship',             page: 'orders',        name: 'Ship Button' },
    { id: 'orders.markUsed',         page: 'stockHouse',    name: 'Mark as Used Button' },
    { id: 'orders.undoUsed',         page: 'orders',        name: 'Undo Used Button' },
    { id: 'orders.processReturn',    page: 'orders',        name: '(Legacy) Return/Restock Buttons' },
    { id: 'orders.restock',          page: 'orders',        name: 'Restock Button' },
    { id: 'orders.undoRestock',      page: 'orders',        name: 'Undo Restock Button' },
    { id: 'orders.processPO',        page: 'orders',        name: 'Process by PO Button' },
    { id: 'orders.createBulkLot',    page: 'orders',        name: 'Create Bulk Lot Button' },
    { id: 'orders.undoProcessPO',    page: 'orders',        name: 'Undo Process by PO Button' },
    { id: 'orders.cancelShipment',   page: 'orders',        name: 'Cancel Shipment Button' },
    { id: 'orders.markPacked',       page: 'stockHouse',    name: 'Mark Packed (Ready to pack)' },
    { id: 'orders.quarantineFabric', page: 'orders',        name: 'Quarantine Fabric Action' },
    { id: 'orders.manualArchive',    page: 'orders',        name: 'Manual Archive (Post-shipped)' },
    { id: 'orders.deleteV9Order',    page: 'orders',        name: 'Delete V9 Order (Admin)' },
    { id: 'orders.forcePackAllocating', page: 'orders',     name: 'Force Pack (Admin Override)' },

    // ── New Orders Page ───────────────────────────────────────────────────
    { id: 'ordersNew.markUsed',       page: 'ordersNew', name: 'Mark as Used' },
    { id: 'ordersNew.undoUsed',       page: 'ordersNew', name: 'Undo Mark Used' },
    { id: 'ordersNew.ship',           page: 'ordersNew', name: 'Pack / Ship (Create Shipment)' },
    { id: 'ordersNew.markPacked',     page: 'ordersNew', name: 'Mark Packed' },
    { id: 'ordersNew.cancelShipment', page: 'ordersNew', name: 'Cancel Shipment' },
    { id: 'ordersNew.restock',        page: 'ordersNew', name: 'Restock' },
    { id: 'ordersNew.undoRestock',    page: 'ordersNew', name: 'Undo Restock' },
    { id: 'ordersNew.processPO',      page: 'ordersNew', name: 'Process by PO (Create Batch)' },
    { id: 'ordersNew.undoProcessPO',  page: 'ordersNew', name: 'Undo Process by PO' },
    { id: 'ordersNew.manualStatus',   page: 'ordersNew', name: 'Update Shipment Status (Manual Courier)' },
    { id: 'ordersNew.snoozeWarning',  page: 'ordersNew', name: 'Snooze Stale Warnings' },

    // ── Order Desk ────────────────────────────────────────────────────────

    // ── V9 Orders ─────────────────────────────────────────────────────────
    { id: 'v9Orders.processPO', page: 'v9Orders', name: 'Create Batch (Process by PO)' },

    // ── V9 Action Queue ───────────────────────────────────────────────────
    { id: 'v9ActionQueue.markUsed',       page: 'v9ActionQueue', name: 'Mark Used' },
    { id: 'v9ActionQueue.pack',           page: 'v9ActionQueue', name: 'Pack (Create Shipment)' },
    { id: 'v9ActionQueue.restock',        page: 'v9ActionQueue', name: 'Restock' },
    { id: 'v9ActionQueue.excessRestock',  page: 'v9ActionQueue', name: 'Excess Restock' },
    { id: 'v9ActionQueue.undoRestock',    page: 'v9ActionQueue', name: 'Undo Restock' },
    { id: 'v9ActionQueue.returnReceive',  page: 'v9ActionQueue', name: 'Return Receive' },
    { id: 'v9ActionQueue.invoiceRefresh', page: 'v9ActionQueue', name: 'Refresh Invoice' },
    { id: 'v9ActionQueue.paymentResolve', page: 'v9ActionQueue', name: 'Resolve Payment Hold' },

    // ── Production & Batch Pages ──────────────────────────────────────────
    { id: 'batches.create',                 page: 'batches', name: 'Create Batch Button' },
    { id: 'batches.receive',                page: 'batches', name: 'Receive Button' },
    { id: 'batches.undoReceive',            page: 'batches', name: 'Undo Receive Button' },
    { id: 'batches.exportCsv',              page: 'batches', name: 'Export CSV Button' },
    { id: 'batches.markReceived',           page: 'batches', name: 'Mark Batch as Received' },
    { id: 'batches.delete',                 page: 'batches', name: 'Delete Batch Button' },
    { id: 'batches.prepareProductionFiles', page: 'batches', name: 'Prepare Production TIFF Files' },
    { id: 'batches.viewCompleted',          page: 'batches', name: 'View Completed / All Batches' },
    { id: 'batches.viewStockDetails',       page: 'batches', name: 'View Stock & Allocation Details' },
    { id: 'batches.printPdf',               page: 'batches', name: 'Print Batch PDF' },
    { id: 'batches.viewPendingReport',      page: 'batches', name: 'View Pending Production Report' },

    // ── Inventory Page ────────────────────────────────────────────────────
    { id: 'inventory.addStock',              page: 'inventory', name: 'Add New Stock' },
    { id: 'inventory.importStock',           page: 'inventory', name: 'Import Opening Stock' },
    { id: 'inventory.exportStock',           page: 'inventory', name: 'Export Stock CSV' },
    { id: 'inventory.exportLedger',          page: 'inventory', name: 'Export Activity CSV' },
    { id: 'inventory.undoImport',            page: 'inventory', name: 'Undo Last Import' },
    { id: 'inventory.adjustStock',           page: 'inventory', name: 'Adjust Stock Button' },
    { id: 'inventory.adjustStock.correction',page: 'inventory', name: 'Adjust Stock (Correction)' },
    { id: 'inventory.adjustStock.damaged',   page: 'inventory', name: 'Adjust Stock (Damaged)' },
    { id: 'inventory.adjustStock.lost',      page: 'inventory', name: 'Adjust Stock (Lost)' },
    { id: 'inventory.adjustStock.split',     page: 'inventory', name: 'Adjust Stock (Split Piece)' },
    { id: 'inventory.deletePiece',           page: 'inventory', name: 'Delete Piece Button' },
    { id: 'inventory.undoAdjustment',        page: 'inventory', name: 'Undo Adjustment Button' },
    { id: 'inventory.audit',                 page: 'inventory', name: 'Manual Stock Audit' },
    { id: 'inventory.quarantineQueueView',   page: 'inventory', name: 'View Quarantine Queue' },
    { id: 'inventory.quarantineQueueAct',    page: 'inventory', name: 'Act on Quarantine Queue' },
    { id: 'inventory.printLabels',           page: 'inventory', name: 'Print Labels' },
    { id: 'inventory.workstationPrinter',    page: 'inventory', name: 'Workstation Printer Setup (QZ Tray)' },

    // ── Fabric Specs Page ─────────────────────────────────────────────────
    { id: 'fabricSpecs.create', page: 'fabricSpecs', name: 'Create New' },
    { id: 'fabricSpecs.edit',   page: 'fabricSpecs', name: 'Edit' },
    { id: 'fabricSpecs.delete', page: 'fabricSpecs', name: 'Delete' },
    { id: 'fabricSpecs.import', page: 'fabricSpecs', name: 'Bulk Import' },

    // ── Add / New Product Actions (on Products page) ────────────────────
    { id: 'addProduct.submit',           page: 'products', name: 'Submit New Product' },
    { id: 'addProduct.edit',             page: 'products', name: 'Edit New Product' },
    { id: 'addProduct.delete',           page: 'products', name: 'Delete New Product' },
    { id: 'addProduct.uploadPhotoshoot', page: 'products', name: 'Upload Photoshoot Images' },
    { id: 'addProduct.generateDetails',  page: 'products', name: 'Generate AI Details' },
    { id: 'addProduct.generateLookbook', page: 'products', name: 'Generate Lookbook' },
    { id: 'addProduct.pushShopify',      page: 'products', name: 'Push to Shopify' },
    { id: 'addProduct.pushZoho',         page: 'products', name: 'Push to Zoho' },

    // ── Admin Page ────────────────────────────────────────────────────────
    { id: 'admin.syncOrders',          page: 'admin', name: 'Sync Orders Buttons' },
    { id: 'admin.syncProducts',        page: 'admin', name: 'Sync Products Button' },
    { id: 'admin.reconcile',           page: 'admin', name: 'Reconcile Orders Button' },
    { id: 'admin.purgeLegacyOrders',   page: 'admin', name: 'Purge Legacy Orders' },
    { id: 'admin.clearZohoTokenCache', page: 'admin', name: 'Clear Zoho Token Cache' },
    { id: 'admin.printJobs',           page: 'admin', name: 'Manage Print Jobs' },

    // ── Products Page ─────────────────────────────────────────────────────
    { id: 'products.myntraStock',      page: 'products', name: 'Myntra Stock Export' },

    // ── Customer Support Page ─────────────────────────────────────────────
    { id: 'support.viewTickets',   page: 'support', name: 'View Tickets Tab' },
    { id: 'support.viewLive',      page: 'support', name: 'View Chats Tab (Instagram / Messenger)' },
    { id: 'support.viewAbandoned', page: 'support', name: 'View Abandoned Checkouts Tab' },
    { id: 'support.viewCustomers', page: 'support', name: 'View Customer Lookup Tab' },
    { id: 'support.viewMetrics',   page: 'support', name: 'View Support Metrics Tab' },
    { id: 'support.createTicket',  page: 'support', name: 'Create Ticket' },
    { id: 'support.updateTicket',  page: 'support', name: 'Update Ticket' },
    { id: 'support.assignTicket',  page: 'support', name: 'Assign Ticket' },
    { id: 'support.aiAgentTab',    page: 'support', name: 'View AI Agent Tab' },
    { id: 'support.archiveTickets', page: 'support', name: 'Archive Old Tickets (no customer email)' },

    // ── Blog Automation ───────────────────────────────────────────────────────
    { id: 'blog.createTopic',  page: 'blog', name: 'Create / Edit Blog Topic' },
    { id: 'blog.approveTopic', page: 'blog', name: 'Approve / Reject Blog Topic' },
    { id: 'blog.publishPost',  page: 'blog', name: 'Approve & Publish Blog Post to Shopify' },

    // ── Zero-Error Fulfillment Hub & Stations ──────────────────────────────
    { id: 'fulfillment.view',           page: 'fulfillment', name: 'View Orders, Batches & Fulfillment Hub' },
    { id: 'fulfillment.verify',         page: 'fulfillment', name: 'Verify COD & Custom Orders' },
    { id: 'fulfillment.pick',           page: 'fulfillment', name: 'Access Warehouse Pick Lists' },
    { id: 'fulfillment.markUsed',       page: 'fulfillment', name: 'Packaging Desk: Mark Stock Used / Reserved' },
    { id: 'fulfillment.createBatch',    page: 'fulfillment', name: 'Production Batch Builder (Deficit Items)' },
    { id: 'fulfillment.receiveBatch',   page: 'fulfillment', name: 'Inbound QC: Receive Factory Pieces (1-by-1)' },
    { id: 'fulfillment.generateLabel',  page: 'fulfillment', name: 'Generate Carrier Shipping Labels' },
    { id: 'fulfillment.pack',           page: 'fulfillment', name: 'Packing Desk: Enter Box Size/Weight & Mark Packed' },
    { id: 'fulfillment.dispatch',       page: 'fulfillment', name: 'Courier Handover & Trigger Auto Invoicing' },
    { id: 'fulfillment.handleNDR',      page: 'fulfillment', name: 'NDR Action Center & WhatsApp Reattempt' },
    { id: 'fulfillment.processReturns', page: 'fulfillment', name: 'Reverse Logistics: Return QC Grading & Credit Notes' },
    { id: 'fulfillment.createExchange', page: 'fulfillment', name: 'Create 1-Click Exchange / Replacement Orders' },

    // Order Desk (appended — never insert mid-list)
    { id: 'orderDesk.office',    page: 'orderDesk', name: 'Office team (verify, batches, invoices)' },
    { id: 'orderDesk.warehouse', page: 'orderDesk', name: 'Warehouse team (mark used, receive, pack, RTO, restock)' },
    { id: 'orderDesk.manager',   page: 'orderDesk', name: 'Manager (all queues, reassign)' },

    // Support manager (appended — never insert mid-list)
    { id: 'support.manageHours', page: 'support', name: 'Support manager: working hours, holidays & auto-replies' },
  ],
};

/**
 * Returns actions grouped by their page, in page display order.
 * Each entry: { pageId, pageName, actions: [...] }
 */
export function getActionsGroupedByPage() {
  const pageOrder = PERMISSIONS_CONFIG.pages.map((p) => p.id);
  const pageNameMap = Object.fromEntries(PERMISSIONS_CONFIG.pages.map((p) => [p.id, p.name]));
  const groups = {};
  PERMISSIONS_CONFIG.actions.forEach((action) => {
    const pid = action.page || 'other';
    if (!groups[pid]) groups[pid] = [];
    groups[pid].push(action);
  });
  const result = pageOrder
    .filter((pid) => groups[pid])
    .map((pid) => ({ pageId: pid, pageName: pageNameMap[pid] || pid, actions: groups[pid] }));
  // Append any actions with unknown page
  if (groups.other) result.push({ pageId: 'other', pageName: 'Other', actions: groups.other });
  return result;
}

export const PAGES_LIST = PERMISSIONS_CONFIG.pages.map((p) => p.id);
export const ACTIONS_LIST = PERMISSIONS_CONFIG.actions.map((a) => a.id);

export function encodePermissions(permissions) {
  if (!permissions) return { p: [], a: [] };
  const pIndices = (permissions.pages || [])
    .map((id) => PAGES_LIST.indexOf(id))
    .filter((idx) => idx !== -1);
  const aIndices = (permissions.actions || [])
    .map((id) => ACTIONS_LIST.indexOf(id))
    .filter((idx) => idx !== -1);
  return { p: pIndices, a: aIndices };
}

export function decodePermissions(encoded) {
  if (!encoded) return { pages: [], actions: [] };
  if (Array.isArray(encoded.pages) && Array.isArray(encoded.actions)) {
    return encoded;
  }
  const pages = (encoded.p || [])
    .map((idx) => PAGES_LIST[idx])
    .filter(Boolean);
  const actions = (encoded.a || [])
    .map((idx) => ACTIONS_LIST[idx])
    .filter(Boolean);
  return { pages, actions };
}

export function decodeClaims(claims) {
  if (!claims) return {};
  const decoded = { ...claims };
  if (decoded.permissions) {
    decoded.permissions = decodePermissions(decoded.permissions);
  }
  return decoded;
}

export const FULFILLMENT_ACTIONS = [
  { id: 'fulfillment.view', name: 'View Orders, Batches & Fulfillment Hub', station: 'General / Hub' },
  { id: 'fulfillment.verify', name: 'Verify COD & Custom Orders', station: 'Station 1: Order Intake' },
  { id: 'fulfillment.pick', name: 'Access Warehouse Pick Lists', station: 'Station 2: Picking Desk' },
  { id: 'fulfillment.markUsed', name: 'Mark Stock Used / Reserved', station: 'Station 2: Packaging Desk' },
  { id: 'fulfillment.createBatch', name: 'Production Batch Builder (Deficit Items)', station: 'Station 3: Production Batching' },
  { id: 'fulfillment.receiveBatch', name: 'Inbound QC: Receive Pieces (1-by-1)', station: 'Station 3: Inbound QC' },
  { id: 'fulfillment.generateLabel', name: 'Generate Carrier Shipping Labels', station: 'Station 4: Shipping Prep' },
  { id: 'fulfillment.pack', name: 'Enter Box Size/Weight & Mark Packed', station: 'Station 4: Packing Desk' },
  { id: 'fulfillment.dispatch', name: 'Courier Handover & Trigger Invoicing', station: 'Station 4: Dispatch Desk' },
  { id: 'fulfillment.handleNDR', name: 'NDR Action Center & WhatsApp', station: 'Station 6: NDR Desk' },
  { id: 'fulfillment.processReturns', name: 'Inbound Return QC & Credit Notes', station: 'Station 7: Returns & Restock' },
  { id: 'fulfillment.createExchange', name: 'Create 1-Click Replacement Orders', station: 'Station 7: Exchanges' },
];

export const FULFILLMENT_PRESETS = {
  picker: {
    label: '📦 Warehouse Picker',
    description: 'Pick lists and packaging mark-used stock locking',
    actions: ['fulfillment.view', 'fulfillment.pick', 'fulfillment.markUsed'],
  },
  packer: {
    label: '🚚 Pack & Dispatch Desk',
    description: 'Weight scale gate, carrier label generation, and courier dispatch',
    actions: ['fulfillment.view', 'fulfillment.generateLabel', 'fulfillment.pack', 'fulfillment.dispatch'],
  },
  production: {
    label: '🏭 Production & Inbound QC',
    description: 'Batch builder, factory work orders, and 1-by-1 piece receiving',
    actions: ['fulfillment.view', 'fulfillment.createBatch', 'fulfillment.receiveBatch'],
  },
  returns_ndr: {
    label: '🔄 Returns & NDR Lead',
    description: 'Delivery exceptions rescue, return QC grading, credit notes, and exchanges',
    actions: ['fulfillment.view', 'fulfillment.handleNDR', 'fulfillment.processReturns', 'fulfillment.createExchange'],
  },
  admin: {
    label: '👑 Full Fulfillment Lead',
    description: 'Complete end-to-end access across all 7 fulfillment stations',
    actions: FULFILLMENT_ACTIONS.map((a) => a.id),
    pages: ['fulfillment'],
  },
};
